import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  @Input() menuData;
  menuItems: any = [
    {
      "meta": {
        "id": 174682
      },
      "label": "Home",
      "url": "#home"
    },
    {
      "meta": {
        "id": 174683
      },
      "label": "About",
      "url": "#about"
    },
    {
      "meta": {
        "id": 174684
      },
      "label": "Services",
      "url": "#features"
    },
    // {
    //   "meta": {
    //     "id": 174686
    //   },
    //   "label": "Testimonials",
    //   "url": "#testimonials"
    // },
    {
      "meta": {
        "id": 174687
      },
      "label": "Blog",
      "url": "#blog"
    }
  ];

  constructor() {
  }

}
